"use strict";

exports.__esModule = true;
exports.changeColumnIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _changeColumnUtils = require("../../Widgets/MetricTable/changeColumnUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var justifyContent = function justifyContent(value) {
  return {
    display: "flex",
    flex: "1",
    margin: "auto 10px",
    justifyContent: value
  };
};
var changeColumnIcon = exports.changeColumnIcon = function changeColumnIcon(change) {
  switch (change) {
    case _changeColumnUtils.CHANGE_UP:
      return /*#__PURE__*/_react["default"].createElement("span", {
        "data-testid": "ChangeColumnIcon",
        style: justifyContent("left"),
        className: _core.Classes.ICON
      }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.ARROW_UP
      }));
    case _changeColumnUtils.CHANGE_DOWN:
      return /*#__PURE__*/_react["default"].createElement("span", {
        "data-testid": "ChangeColumnIcon",
        style: justifyContent("left"),
        className: _core.Classes.ICON
      }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.ARROW_DOWN
      }));
    case _changeColumnUtils.CHANGE_STABLE:
      return /*#__PURE__*/_react["default"].createElement("span", {
        "data-testid": "ChangeColumnIcon",
        style: justifyContent("left"),
        className: _core.Classes.ICON
      }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.MINUS
      }));
    default:
      return null;
  }
};